export default __webpack_public_path__ + "static/vps-e3750543460c4cc3613b84a9297aae59.jpg";